/* sb-dc-cartnav.js — go to the cart page after a successful add.

   The v5.x cart module (sbdc-cart) POSTs to /cart/add.js and stops there:
   the line item lands in the cart, but the customer is left sitting on the
   design center with no sign of where the order went. This adds the
   navigation without touching the 314KB augment bundle.

   The one case that must NOT navigate is "add and design another product",
   which calls __dcAddToCart() and then __dcNewDesign() synchronously. The
   upload + add takes seconds, so __dcNewDesign always lands long before the
   promise settles — we use that to tell the two paths apart. */
(function () {
  'use strict';

  var another = false;   // set by __dcNewDesign while an add is in flight

  function cartUrl() {
    var root = '/';
    try { root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; } catch (e) {}
    return root + 'cart';
  }

  function wrapAdd(orig) {
    return function () {
      another = false;
      var out;
      try { out = orig.apply(this, arguments); } catch (e) { throw e; }
      if (!out || typeof out.then !== 'function') return out;
      return out.then(function (ok) {
        // Only a clean success navigates. Failures already show their own
        // error panel, and we must not navigate away from it.
        if (ok === true && !another) {
          setTimeout(function () { window.location.href = cartUrl(); }, 150);
        }
        another = false;
        return ok;
      }, function (e) { another = false; throw e; });
    };
  }

  function wrapNew(orig) {
    return function () {
      another = true;
      return orig.apply(this, arguments);
    };
  }

  var doneAdd = false, doneNew = false, tries = 0;
  var timer = setInterval(function () {
    if (!doneAdd && typeof window.__dcAddToCart === 'function' && !window.__dcAddToCart.__navWrapped) {
      var f = wrapAdd(window.__dcAddToCart);
      f.__navWrapped = true;
      window.__dcAddToCart = f;
      doneAdd = true;
    }
    if (!doneNew && typeof window.__dcNewDesign === 'function' && !window.__dcNewDesign.__navWrapped) {
      var g = wrapNew(window.__dcNewDesign);
      g.__navWrapped = true;
      window.__dcNewDesign = g;
      doneNew = true;
    }
    if ((doneAdd && doneNew) || ++tries > 100) clearInterval(timer);
  }, 200);
})();
